import React, { useState } from "react";
import 'react-csv-importer/dist/index.css';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from "@mui/icons-material/Error";
import { useTheme } from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { useSetStatusClosingMutation } from "../../../../../slices/api/apiSlice";
import { setLeadActionNavMenuSelection } from "../../../../../slices/sessionDataSlice";
import { selectSetInvestigationClosingPerm } from "../../../../../slices/userActionsPermissionsSlice";
import { Button } from "../../../../../StyledComponents";
import WorkflowPanel, { DecisionCard, DecisionCopy, DecisionTitle, WorkflowBody, WorkflowFooter, WorkflowHeader, WorkflowScroll } from "./WorkflowPanel";

const BeginClosing = ({ handleCloseModal, userId, teamId, userFullName, leadData }) => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const [setStatusClosing] = useSetStatusClosingMutation()

  const setInvestigationClosingPerm = useSelector(selectSetInvestigationClosingPerm)

  const [isError, setIsError] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleSetClosing = async () => {
    setIsLoading(true)
    setIsError(false)
    let resp = await setStatusClosing({
      leadId: leadData._id,
      teamId: teamId,
      userId: userId,
      timeline: leadData.timeline,
      userFullName: userFullName,
      mortgageId: leadData.belongsToMortgage._id,
    })
    if (resp.error) {
      setIsError(true)
    } else if (resp.data.message.includes('success')) {
      setIsSuccess(true)
    } else {
      setIsError(true)
    }
    setIsLoading(false)
  }

  const handleGoToFinalize = () => {
    dispatch( setLeadActionNavMenuSelection('finalizeLead'))
  }

  return (
    <WorkflowPanel>
      {isSuccess ?
        <WorkflowHeader tone="success" title="Success" icon={<CheckIcon />} />
      : isError ?
        <WorkflowHeader tone="error" title="Failed... please try again. Reach out to support@lancastersweep.com if the problem persists." icon={<ErrorIcon />} />
      :
        <WorkflowHeader title="Initiate Closing" subtitle="Move this investigation into the closing workflow." />
      }

      <WorkflowBody>
        <WorkflowScroll className="centered">
          <DecisionCard>
            <DecisionTitle>{isSuccess ? "Closing initiated" : "Confirm closing transition"}</DecisionTitle>
            <DecisionCopy>
              {isSuccess ?
                `The ${leadData.targetOutcome.toUpperCase() === 'RENEGOTIATION' ? 'renegotiation' : 'refinance'} has been moved to closing.`
              :
                `Move the ${leadData.targetOutcome.toUpperCase() === 'RENEGOTIATION' ? 'renegotiation' : 'refinance'} to closing?`
              }
            </DecisionCopy>
          </DecisionCard>
        </WorkflowScroll>
        <WorkflowFooter>
          {isSuccess ?
            <>
              <Button className="neutral" onClick={() => handleCloseModal()}>close</Button>
              <Button className="primary" onClick={() => handleGoToFinalize()} style={{width: '15rem'}}>go to Finalize</Button>
            </>
          :
            <Button 
              onClick={setInvestigationClosingPerm ? () => handleSetClosing() : null} 
              className={!setInvestigationClosingPerm ? "primaryDisabled" : isLoading ? "primaryLoading" : "primary"}
            >
              {isLoading ?
                <CircularProgress
                  sx={{ color: `${theme.palette.common.cardBackground}` }}
                  size={13}
                />
              :
                `Confirm`
              }
            </Button> 
          }
        </WorkflowFooter>
      </WorkflowBody>
    </WorkflowPanel>
  )
}

export default BeginClosing;
